export const SrasCanonicalAreas = [
  "INTRODUCTION",
  "PURPOSE",
  "HULL BELOW WATERLINE",
  "UNDERWATER GEAR",
  "DRIVE UNITS",
  "WATERLINE TO GUNWALES",
  "SUPERSTRUCTURE",
  "DECK AND COACHROOF",
  "COCKPIT",
  "LAZERETTE",
  "LAZERETTE - FORWARD",
  "COCKPIT LOCKER - PORT",
  "COCKPIT LOCKER - STARBOARD",
  "FOREDECK LOCKER",
  "DECK FITTINGS & EQUIPMENT",
  "FLYBRIDGE",
  "HELM POSITION / WHEELHOUSE",
  "STANDING RIGGING",
  "RUNNING RIGGING",
  "ACCOMMODATION SPACE - GENERAL",
  "AFT HEADS COMPARTMENT",
  "AFT CABIN - PORT",
  "AFT CABIN - STARBOARD",
  "HEADS COMPARTMENT",
  "GALLEY",
  "SALOON",
  "AMIDSHIPS CABIN",
  "NAVIGATION TABLE",
  "FORWARD CABIN",
  "FORWARD HEADS PORT",
  "FORWARD HEADS STARBOARD",
  "COMPANIONWAY CORRIDOR",
  "CREW CABIN",
  "CONSOLE",
  "TUBES",
  "TENDER GARAGE",
  "ENGINE SPACE",
] as const;
